import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';
import { IPaymentResponse } from 'types/payment';

export const listPayments = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<
    IBodyResponse<{
        payments: IPaymentResponse[];
        total_items: number;
    }>
> => {
    const response = await axiosInstance.get('admin/payments', {
        params,
    });
    return response.data;
};

export const paymentDetailById = async (
    id: number
): Promise<
    IBodyResponse<{
        payment: IPaymentResponse;
    }>
> => {
    const response = await axiosInstance.get(`admin/payments/${id}`);
    return response.data;
};

export const updatePayment = async (
    id: number,
    data: any // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<
    IBodyResponse<{
        payment: IPaymentResponse;
    }>
> => {
    const response = await axiosInstance.put(`admin/payments/${id}`, data);
    return response.data;
};

export const CheckPricePayment = async (
    data: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.post(
        `admin/payments/check_price`,
        data
    );
    return response.data;
};

export const CreatePayment = async (
    data: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.post(`admin/payments`, data);
    return response.data;
};

export const paymentDetail = async (
    id: number
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/payments/${id}`);
    return response.data;
};

export const listPlanPayment = async (
    params: any // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(`admin/plans`, {
        params,
    });
    return response.data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const exportPayment = async (params: any): Promise<any> => {
    const response = await axiosInstance.get('admin/payments/export_data', {
        params,
        responseType: 'blob',
    });
    return response.data;
};
